'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reduceControl = reduceControl;

var _workflow = require('../../constants/actions/workflow');

function reduceControl(payload) {
    return {
        type: _workflow.REDUCE_CONTROL,
        payload: payload
    };
}